// extracted by mini-css-extract-plugin
export default {"title":"a8e8aae507","bld":"_57a8e76d25"};